module.exports = __webpack_public_path__ + "static/obafemi-efc8ad08a7e8282ec97cb3fdd578e3f9.png";